import { Box, Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../../data/Axios/DynamicService";
import { HRService } from "../../../../config";
import { employeePayColumns } from "../../../../data/Columns/hrmanagement";
import EmployeePayForm from "./EmployeePayForm";
import { AllEmployeePayComponent, allEmployeePayQuery } from "../../../../data/Queries/HRmanagement/leavemanagement";
import { useNavigate, useLocation } from "react-router-dom";

const base_url = HRService.uri;

function EmployeePayTable() {
  const location = useLocation();

  const navigate = useNavigate();
  const handleGoBack = () => {
    const backPath = location.state?.from || "/employees";
    navigate(backPath);
  };
  
  const data = 
    location.state?.employeeData ||
    JSON.parse(localStorage.getItem("EmployeeData"));
  const ImprestId = data.id;
  
  const actions = {
    entity: "Employee Management",
    isSubright: true,

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
   
    dataObject: {
      inputFields: {
        employeeId: ImprestId,
      },
      inputObjectName: "employeePayComponentByEmployeeId",
      inputSubObjectName: "employeePayComponent",
      returnFields: [
        "id",
        "employeeId",
        "payComponentId",
        "employeeName",
        "payComponentName",
        "amount",
        "percentOfBase",
        "baseComponentCode",
        "effectiveFrom",
        "effectiveTo",
        "isActive",
        "notes",
        "createdBy",
        "createdAt",
      ],
    },

    showStatus: true,
  };

  const title = `Payment Structure For ${data.firstName} ${data.lastName || data.id}`;

  return (
    <Box m="2px">
      <>
        {/* Floating Back Button */}
        <Fab
          color="secondary"
          aria-label="go back"
          onClick={handleGoBack}
          sx={{
            position: "fixed",
            top: 120,
            left: 270,
            zIndex: 1100,
            width: 40,
            height: 40,
            boxShadow: 3,
            "&:hover": {
            boxShadow: 6,
            },
          }}
        >
          <ArrowBackIcon />
        </Fab>

        <DynamicTable
          title={title}
          subtitle="View all the Employee Pay Data, create or update it"
          columns={employeePayColumns}
          FormComponent={EmployeePayForm}
          // query={AllEmployeePayComponent}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default EmployeePayTable;